import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { type Mode, type Theme, getThemeStyle } from "~/features/ui/get-theme-style";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
const fragment = graphql(`
  fragment GraphicStatsStat on blocks_graphicStatsStat_BlockType {
    stat: baseText
  }
`);
type Props = FragmentType<typeof fragment> & {
  mode: Mode;
  theme: Theme;
};
export type GraphicStatsStatViewProps = {
  stat?: string | null;
  mode: Mode;
  theme: Theme;
};
export function GraphicStatsStatView({
  stat,
  mode,
  theme
}: GraphicStatsStatViewProps) {
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  return <_StyledLi $_css={[{
    "display": "flex",
    "alignItems": "center",
    "gap": "1.6rem",
    "borderTopWidth": "1px",
    "paddingLeft": "1.6rem",
    "paddingRight": "1.6rem",
    "paddingTop": "2rem",
    "paddingBottom": "2rem"
  }, themeStyle.border]}>
      <_StyledDiv />
      <_StyledSpan>{stat}</_StyledSpan>
    </_StyledLi>;
}
export function GraphicStatsStat(props: Props) {
  const {
    mode = "light",
    theme = "white",
    ...rest
  } = props;
  const {
    stat
  } = useFragment(fragment, rest);
  return <GraphicStatsStatView stat={stat} mode={mode} theme={theme} />;
}
var _StyledLi = /*#__PURE__*/_styled("li").withConfig({
  componentId: "sc-sf-1fux1le-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-1fux1le-1"
})({
  "height": "0.8rem",
  "width": "0.8rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});
var _StyledSpan = /*#__PURE__*/_styled3("span").withConfig({
  displayName: "stat___StyledSpan",
  componentId: "sc-13dlcfg-0"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.8rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.018rem",
    "fontWeight": "400"
  }
});